import { Component } from 'preact';
import styled from 'styled-components';

class JobOpenings extends Component {

	constructor(props) {
		super(props);
		this.state = {
			language: null
		};
	}

	render() {
		
		const JobOpeningsContainer = styled.div`
			align-items: center;
			background: url(${this.context.branding.jobsBackground});
			background-position: center center;
			background-repeat: no-repeat;
			background-size: cover;
			display: flex;
			flex-direction: column;
			height: 30rem;
			justify-content: center;
			h2 {
				color: ${this.context.colors.link};
				font-family: ${this.context.branding.headerFont};
				font-size: 4.6rem;
				margin: 0;
				text-align: center;
				text-transform: uppercase;
				@media only screen and (max-width: 680px) {
					font-size: 3rem;
					line-height: 1.25;
				}
			}
			a {
				background-color: ${this.context.colors.accent};
				color: ${this.context.colors.link};
				font-family: ${this.context.branding.headerFont};
				font-size: 1.4rem;
				font-weight: 600;
				padding: 1.7rem 2.2rem;
				margin-top: 1rem;
				text-decoration: none;
				text-transform: uppercase;
				@media only screen and (max-width: 680px) {
					margin-top: 3rem;
				}
				&:hover {
					background-color: ${this.context.colors.primary};
				}
			}
		`;

		return (
			<JobOpeningsContainer id="careers">
				<h2>{`Work At ${this.context.copy.shortName}`}</h2>
				<a href={this.context.branding.jobsUrl} target="_blank">All Jobs</a>
			</JobOpeningsContainer>
		);
	}
}

export default JobOpenings;


// WEBPACK FOOTER //
// ./components/JobOpenings.js